'use client';

import { FC } from 'react';
import { TextButton } from '@tuic/web-compositions/core/TextButton';
import { useThirdPartyEvent } from '@tuic/lib/src/hooks';
import { EVENT_PHASER_OPENER } from '@modules/phaser/config';
import { useClientTranslation } from '@lib/i18n/client';
import { usePhaser } from '../lib/phaser-context';
export const PhaserButton: FC = () => {
  const {
    t
  } = useClientTranslation();
  const {
    invoke: openPhaser
  } = useThirdPartyEvent(EVENT_PHASER_OPENER);
  const phaser = usePhaser();
  if (!phaser?.render) {
    return null;
  }
  return <div className="text-center" data-sentry-component="PhaserButton" data-sentry-source-file="phaser-button.tsx">
      <TextButton onClick={() => openPhaser()} data-sentry-element="TextButton" data-sentry-source-file="phaser-button.tsx">
        {t('Debug-Tool öffnen')}
      </TextButton>
    </div>;
};